export const HOOKS = {
  MATCH_END: {
    TEST: 'https://discord.com/api/webhooks/1282178649931518033/AKDWTBiIChjwnE2YTDT3oNaGC3HyAAl7Ddd5D490M97PrwwfoAx7ZzKyHZkpugG6Xcrn',
    PROD: 'https://discord.com/api/webhooks/1282178815476371527/RHtXiFW-mG9Vg0jwgG34lOoT_XKot2fFxwWwlhRVA4zgWJhKMsR0IjP65SHQFan2_awv',
  },
};
